module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"Update Category":"Изменить категорию","New category":"Новая категория","confirm_deletion":"Вы действительно хотите удалить выбранные транзакции? Балансы счетов и конвертов не будут изменены при массовом удалении."},"en":{"confirm_deletion":"Are you sure you want to delete selected transactions? Bulk destroy doesn\u0027t update accounts and envelopes balances."}}')
  delete Component.options._Ctor
}
